// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__21U-B","header":"PatientBlock_header__uDhsB","label":"PatientBlock_label__36usT","option":"PatientBlock_option__QXG9v"};